<template>
  <vs-row>
    <b-loading :is-full-page="true" v-model="isLoading" />
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card>
        <div slot="header">
          <h3 class="card-title mb-0">Criterios de búsqueda</h3>
        </div>
        <div class="columns">
          <div class="column">
            <CompanySelector v-model="companyId" />
          </div>
          <div class="column">
            <b-field label="Identificación y/o nombre">
              <div class="control-content">
                <GenericAutocomplete name="entity"
                                     v-model="entity"
                                     label="name"
                                     placeholder="Buscar propietario..."
                                     :search-records="findEntity" />
              </div>
            </b-field>
          </div>
          <div class="column">
            <b-field label="Número de tarjeta">
              <b-input placeholder="Número tarjeta"
                       type="text"
                       v-model="cardId" />
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-4">
            <b-field label="Matrícula, placa y/o descripción">
              <b-input placeholder="Matrícula y/o placa"
                       type="text"
                       v-model="plate" />
            </b-field>
          </div>
          <div class="column is-4">
            <b-field label="Tipo de servicio *">
              <b-select
                placeholder="Seleccione un servicio"
                expanded
                v-model="serviceType"
                name="serviceType">
                <option v-for="option in serviceTypeList"
                        :key="option.code"
                        :value="option">
                  {{ option.title }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column">
            <vs-button color="primary"
                       type="filled"
                       @click="find"
                       style="margin-top: 30px; width: 150px;">
              Buscar
            </vs-button>
          </div>
        </div>
        <div ref="divTable">
          <vs-table
            v-if="showTable"
            stripe
            :data="monthlyList"
            max-items="10" pagination>
            <template #thead>
              <vs-th>Nombre</vs-th>
              <vs-th>Identificación</vs-th>
              <vs-th>Valor</vs-th>
              <vs-th>Lote</vs-th>
              <vs-th>Artículos</vs-th>
              <vs-th>Opciones</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="item in data"
                     :key="item.specialCode">
                <vs-td>{{ item.entityName }}</vs-td>
                <vs-td>{{ item.entityIdentification }}</vs-td>
                <vs-td>{{ currency(item.total) }}</vs-td>
                <vs-td>{{ item.slot }}</vs-td>
                <vs-td>
                <span v-if="!isLarge(item.items)">
              {{ processItems(item.items) }}
              </span>
                  <vs-tooltip v-else :text="allItems(item.items)">
                    <span>{{ processItems(item.items) }} </span> <span class="btn-link">ver más</span>
                  </vs-tooltip>
                </vs-td>

                <vs-td>
                  <button
                    class="btn primary edit"
                    @click="viewMonthly(item.specialCode)"
                    title="Editar">
                    <span class="material-icons"> edit </span>
                  </button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import CompanySelector from '@/components/Shared/CompanySelector'
import GenericAutocomplete from '@/components/Shared/Autocomplete/GenericAutocomplete'
import incomeSpecialEndpoint from '@/endpoints/billing/IncomeSpecialEndpoint'
import unityEndpoint from '@/endpoints/core/UnityEndpoint'
import kind from '@/global/lasting/EKind'
import toast from '@/global/ToastConfig'
import { formatPrice } from '@/global/utils'

export default {
  name: 'ListSubscriber',
  components: { CompanySelector, GenericAutocomplete },
  data() {
    return {
      companyId: null,
      entity: { code: null, name: '' },
      cardId: null,
      plate: null,
      perPage: 50,
      total: 0,
      page: 1,
      defaultSortOrder: 'asc',
      sortOrder: 'asc',
      sortField: 'name',
      loading: false,
      monthlyList: [],
      serviceType: null,
      serviceTypeList: [],
      isLoading: false,
      showTable: false
    }
  }, mounted() {
    unityEndpoint.getUnityListByKind(kind.MONTHLY_SERVICE_TYPE, 'servicios')
      .then((info) => this.serviceTypeList = info)
  }, methods: {
    findEntity({ searchQuery, callback }) {
      incomeSpecialEndpoint.listEntity(this.companyId, searchQuery)
        .then(info => callback(info))
    },
    find() {
      if (!this.companyId) {
        toast.error('Debe seleccionar una empresa')
        return
      }
      this.isLoading = true
      this.showTable = false
      const criteria = {
        companyId: this.companyId,
        entityId: this.entity ? this.entity.code : null,
        cardId: this.cardId,
        plate: this.plate,
        serviceType: this.serviceType ? this.serviceType.code : null,
        page: this.page - 1,
        order: this.sortOrder,
        limit: 50000
      }
      incomeSpecialEndpoint.list(criteria)
        .then(info => {
          this.isLoading = false
          this.monthlyList = info.records
          this.total = info.total
          this.$refs.divTable.scrollIntoView({ behavior: 'smooth' })
          this.showTable = true
        })
    },
    viewMonthly(specialId) {
      this.$router.push({ name: 'CREAR ABONADO', params: { subscriberId: specialId } })
    },
    onPageChange(page) {
      this.page = page
      this.find()
    },
    onSort(field, order) {
      this.sortField = field
      this.sortOrder = order
      this.find()
    },
    processItems(items) {
      if (!items) return '-'
      const json = JSON.parse(items)
      const isLarge = this.isLarge(items)
      return isLarge
        ? json.slice(0, 5).join(' - ')
        : json.join(' - ')
    },
    allItems(items) {
      if (!items) return '-'
      return JSON.parse(items).join(' - ')
    },
    isLarge(items) {
      if (!items) return false
      const json = JSON.parse(items)
      return json.length > 5
    },
    currency(value) {
      return formatPrice(value)
    }
  }
}
</script>

<style scoped>

</style>